<div class="myPurchase-dialog-container">
    <div class="myPurchase-dialog-header">
        Upload as checked items
    </div>
    <div class="myPurchase-dialog-content">
        <div class="center">
            <ngx-file-drop dropZoneLabel="Drag and drop files here" (onFileDrop)="dropped($event)" accept=".csv"
                [directory]="false" [multiple]="false" dropZoneClassName="file-upload-dropzone dashed">
                <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
                    <a (click)="openFileSelector()">
                        <div class="upload-info-container">
                            <div class="upload-info-row">
                                <div class="upload-info-col icon-container icon-col-header">
                                    <mat-icon svgIcon="mp-cloud-update" class="upload"></mat-icon>
                                </div>
                                <div class="upload-info-col header">
                                    <p><span class="hyperlink">Choose a file</span> to upload</p>
                                    <p class="subheader">or drag and drop it here</p>
                                </div>
                            </div>
                            <div class="upload-info-row">
                                <div class="upload-info-col icon-container">
                                    <mat-icon svgIcon="mp-straighten" class="straighten"></mat-icon>
                                </div>
                                <div class="upload-info-col">
                                    <p>Max file size 50mb.</p>
                                </div>
                            </div>
                            <div class="upload-info-row">
                                <div class="upload-info-col icon-container">
                                    <mat-icon svgIcon="mp-description" class="description"></mat-icon>
                                </div>
                                <div class="upload-info-col">
                                    <p>Format allowed: csv</p>
                                </div>
                            </div>
                        </div>
                    </a>
                </ng-template>
            </ngx-file-drop>
        </div>
        <div class="file-info">
            <div class="file-name-input">
                <p class="file-name-label">File name:</p>
                <p *ngIf="!file?.name" class="file-name-value">No file chosen</p>
                <p *ngIf="file?.name" class="file-name-value"><span>{{file!.name}}</span>
                    <button mat-icon-button (click)="removeFile()" [disabled]="loading">
                        <mat-icon>close</mat-icon>
                    </button>
                </p>
            </div>
            <div class="form-inputs">
                <p>Status:</p>
                <div class="message-container">
                    <ng-container *ngFor="let sm of statusMessage">
                        <div [ngClass]="{'success': sm.type == 1, 'error': sm.type == 3}" [innerHTML]="sm.message">
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
    <div class="myPurchase-dialog-actions">
        <div mat-dialog-actions>
            <app-button class="mar-r-10 large-button" name="Cancel" (click)="handleClose()" />
            <app-button class="large-button" tabindex="0" name="Upload" type="flat-button"
                [disabled]="!(!hasMessageError() && file != null)" (click)="handleSubmit()" />
        </div>
    </div>
</div>